// utils/markdownParser.ts
export type TimelineItem = {
  time: string;
  title: string;
  subtitle?: string;
  badge?: string;
  extra?: string;
  color?: string;
};

export type Segment =
  | { type: "text"; content: string }
  | { type: "timeline"; items: TimelineItem[] }
  | { type: "card"; content: string }

const BLOCK_RE = /:::(timeline|card)(?:\{[^\}]*\})?\s*\n([\s\S]*?)\n:::/g;

function parseTimelineBlockContent(block: string): TimelineItem[] {
  const lines = block.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const items: TimelineItem[] = [];

  for (const line of lines) {
    const parts = line.split("|").map((p) => (p || "").trim());
    const [time = "", title = "", subtitle = "", badge = "", extra = "", color = ""] = parts;
    items.push({
      time,
      title,
      subtitle: subtitle || undefined,
      badge: badge || undefined,
      extra: extra || undefined,
      color: color ? color.toLowerCase() : undefined,
    });
  }

  return items;
}

export function splitIntoSegments(markdown: string): Segment[] {
  const segments: Segment[] = [];
  let lastIndex = 0;
  let m: RegExpExecArray | null;

  while ((m = BLOCK_RE.exec(markdown)) !== null) {
    const fullStart = m.index;
    const fullEnd = BLOCK_RE.lastIndex;
    const type = m[1];
    const inner = m[2] || "";

    // texto antes del bloque
    if (fullStart > lastIndex) {
      const textBefore = markdown.slice(lastIndex, fullStart);
      if (textBefore.trim()) segments.push({ type: "text", content: textBefore });
    }

    if (type === "timeline") {
      segments.push({ type: "timeline", items: parseTimelineBlockContent(inner) });
    } else if (type === "card") {
      segments.push({ type: "card", content: inner.trim() });
    }
    lastIndex = fullEnd;
  }

  // texto restante
  if (lastIndex < markdown.length) {
    const tail = markdown.slice(lastIndex);
    if (tail.trim()) segments.push({ type: "text", content: tail });
  }

  return segments;
}
